export const users: Record<string, string> = {
  'Choose all projects or a specific selection. An empty selection grants no project access.':
    'Az összes projekt vagy egy kijelölt csoport. Üres kijelölés esetén nincs projekthozzáférés.',
  'Removes mobile access. Historical authorship is retained.':
    'Megszünteti a mobilhozzáférést. A korábbi bejegyzések szerzője megmarad.',
  'Admin user created.': 'A webes felhasználó létrejött.',
  'Admin user removed.': 'A webes hozzáférés törölve.',
  'Admin user updated.': 'A webes felhasználó módosítva.',
  'Admin users': 'Webes felhasználók',
  'All organisation projects': 'A szervezet összes projektje',
  'At least one role is required.': 'Válasszon legalább egy szerepkört.',
  'Create admin user': 'Új webes felhasználó',
  'Display name': 'Megjelenített név',
  'Last sign-in': 'Utolsó bejelentkezés',
  'Licence administrator': 'Licencadminisztrátor',
  'Master data administrator': 'Törzsadat-adminisztrátor',
  'No projects selected: this user will have no project access.':
    'Nincs kijelölt projekt: a felhasználó egyetlen projekthez sem fér hozzá.',
  'Organisation administrator': 'Szervezeti adminisztrátor',
  'Project access': 'Projekthozzáférés',
  'Remove this administration user?': 'Törli a webes hozzáférést?',
  'Report user': 'Jelentéskészítő',
  'Save admin user': 'Felhasználó mentése',
  'Selected projects': 'Kijelölt projektek',
  'Ticket manager': 'Hibajegykezelő',
  'Ticket viewer': 'Hibajegyek megtekintője',
  'Web administration invitations': 'Webes meghívók',
  Removed: 'Törölve',
  'Edit project access': 'Projekthozzáférés módosítása',
  'Unavailable projects': 'Nem elérhető projektek',
  'Remove assignment': 'Hozzárendelés eltávolítása',
  'Reload user': 'Felhasználó újratöltése',
  'Refresh projects': 'Projektek frissítése',
  'Edit admin user': 'Admin felhasználó szerkesztése',
  Pending: 'Függőben',
};
